export default __webpack_public_path__ + "static/media/left.e550c5de.svg";